import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import NavBar from './NavBar/index';
import ClientNavBar from './NavBar/ClientNavBar';
import TopBar from './TopBar';
import useIsClientView from 'src/hooks/useIsClientView';
import useHashReference from 'src/hooks/useHashReference';
import { useParentClientCache } from '../../contexts/ParentClientCacheContext';

const DashboardLayout = ({ children, routes }) => {
  const [isNavOpen, setNavOpen] = useState(true);
  const [parentClient, setParentClient] = useState({});
  const isClientView = useIsClientView();
  const hashReference = useHashReference();
  const { getParentClientByHashReference } = useParentClientCache();

  useEffect(() => {
    getParentClient();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getParentClient = async () => {
    if (isClientView && hashReference) {
      const cachedParentClient = await getParentClientByHashReference(hashReference);
      if (cachedParentClient) {
        setParentClient(cachedParentClient);
      }
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: 'background.dark',
        display: 'flex',
        minHeight: '100%',
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <TopBar onNavOpen={() => setNavOpen(!isNavOpen)} />
      {isClientView ? (
        <ClientNavBar openMobile={true} parentClientName={parentClient?.name} />
      ) : (
        <NavBar onNavClose={() => setNavOpen(false)} routes={routes} openMobile={isNavOpen} />
      )}
      <Box
        sx={{
          display: 'flex',
          flex: '1 1 auto',
          overflow: 'hidden',
          paddingTop: 10,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flex: '1 1 auto',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              flex: '1 1 auto',
              height: '100%',
              overflow: 'hidden',
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
